<!-- ECharts chart: created on mount, updated when options change, resizes with its container. -->
<script lang="ts">
  import { echarts } from "../charts";
  import type { Opt } from "../lib/chart";
  let { option, class: cls = "", style, id }: { option: Opt | null; class?: string; style?: string; id?: string } = $props();
  let el: HTMLDivElement;
  let chart: ReturnType<typeof echarts.init> | undefined;

  $effect(() => {
    const c = echarts.init(el);
    chart = c;
    const ro = new ResizeObserver(() => c.resize());
    ro.observe(el);
    return () => {
      ro.disconnect();
      c.dispose();
      chart = undefined;
    };
  });
  $effect(() => {
    const o = option;
    if (chart && o) chart.setOption(o, { notMerge: true });
  });
</script>

<div bind:this={el} class="chart {cls}" {style} {id}></div>
